import PropTypes from "prop-types"
import styled from "styled-components"
import { paragraphTextTheme, lightGreyColor } from "../../theme"
import { fontRegular, fontSemiBold } from "../../utils/fontFamily"

const P = styled.p`
  color: ${({ whiteText }) => (whiteText ? "#ffff" : paragraphTextTheme)};
  ${fontRegular()};
  line-height: 1.5;
  margin-top: ${props => `${props.marginTop}px`};
  margin-bottom: ${props => `${props.marginBottom}px`};
&.pricing-sub-header{
  font-weight: 600 !important;
  color: #777;
}
 
.padding-left-50{
  padding-left: 50px;
}
  ${({ semiBold }) =>
    semiBold &&
    `
    color: ${lightGreyColor}
  ${fontSemiBold()}
  `};
  

  ${({ semiBold }) =>
    semiBold &&
    `
    color: ${lightGreyColor}
  ${fontSemiBold()}
  `};

  ${({ theme }) => theme.se`
   font-size: 16px;
  `}

  ${({ theme }) => theme.tablet`
   font-size: 18px;
  `}

  ${({ theme }) => theme.desktop`
      font-size: 20px;
        &.plan-description{
        font-size: 18px;
      }
  `}

  ${({ theme }) => theme.largeDesktop`
      font-size: 22px;
      &.features-description{
        font-size: 20px;
      }
  `}
`

P.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  invert: PropTypes.bool,
  whiteText: PropTypes.bool,
  className: PropTypes.string,
}

P.defaultProps = {
  invert: false,
  className: "",
  whiteText: false,
  className: "",
  marginTop: 0,
  marginBottom: 25,
}

export default P
